<template>
  <div>
    <nav-back url="/login"></nav-back>
    <div class="padding-h-20">
      <div class="font-27 color-14171B font-bold margin-t-70">Enter OTP Code</div>

      <div class="font-14 color-14171B font-bold opacity-90 margin-t-36">Please enter SMS OTP to verify your phone number.</div>

      <sms_code_input class="margin-t-41" v-model="smsCode" :number="6"></sms_code_input>

      <div class="font-14 color-14171B font-bold opacity-90 margin-t-30" style="text-align: center">Short SMS OTP not received,</div>

      <div class="flex-h margin-t-19 flex-space-between" v-show="!showCountDown">
        <div class="color-1477FE font-bold font-14 margin-l-30" @click="sendSmsCode(2)">Try voice OTP</div>

        <div class="color-1477FE font-bold font-14 margin-r-30" @click="sendSmsCode(1)">Resend OTP</div>
      </div>

      <div class="flex-h flex-h-center margin-t-19" v-show="showCountDown">
        <van-count-down :time="time" :auto-start="false" ref="countDown" @finish="countDownFinished()">
          <template #default="timeData">
            <div class="radius-18 bg-F2F4F7 h-35 w-120 flex-h flex-h-center flex-v-center font-16 font-bold color-1477FE" @click="countDownStart()">
              <span>{{ timeData.seconds }}S resend</span>
            </div>
          </template>
        </van-count-down>
      </div>

      <div class="margin-t-56 color-FFFFFF font-bold">
        <van-button style="height: 55px; border-radius: 8px; font-size: 19px" color="linear-gradient(to right,#1093FF, #69BBFF)" :disabled="smsCode.length !== 6" @click="login()" block> SMS OTP </van-button>
      </div>
    </div>
  </div>
</template>

<script>
import navBack from '@/components/nav_back'
import sms_code_input from '@/components/sms_code_input'
import { associateCallSale } from '@/api/app'
import { downApp } from '@/utils/app'
export default {
  name: 'sms_code',
  components: {
    sms_code_input,
    navBack
  },
  data() {
    return {
      phone: '',
      smsCode: '',
      smsType: 1,
      time: 60 * 1000,
      showCountDown: false,
      newUser: false,
      newUserOperatorId: 0
    }
  },
  mounted() {
    this.phone = this.$route.query.phone
    this.sendSmsCode(1)
  },
  methods: {
    repayment() {
      this.$router.replace({
        path: 'home'
      })
    },
    sendSmsCode(type) {
      this.smsType = type
      let params = {
        phone: this.phone,
        type: type
      }
      if (!this.phone) {
        this.$toast('Please fill in your phone number')
        return
      }
      this.$showLoading()
      const operatorId = sessionStorage.getItem('operatorId')
      if (operatorId) {
        params.rlatedType = 1 // 不是老用户 验证码接口获取添加标识 不然不能请求成功
        this.newUser = true
        this.newUserOperatorId = operatorId
      } else {
        this.newUser = false
      }
      this.$request
        .sendSmsCode(params)
        .then(() => {
          this.$hideLoading()
          this.$toast('send success')
          this.showCountDown = true
          this.countDownStart()
        })
        .catch(() => {
          this.$hideLoading()
        })
    },
    async login() {
      let params = {
        phone: '234' + this.phone,
        type: this.smsType,
        verifyCode: this.smsCode
      }
      this.$showLoading()

      // 绑定电销用户

      if (this.newUser) {
        await associateCallSale({ operatorId: this.newUserOperatorId, phone: this.phone })
        downApp(this.phone)
        sessionStorage.removeItem('operatorId') //点击后清除
        return
      }

      this.$request
        .loginSignIn(params)
        .then((res) => {
          this.$hideLoading()
          sessionStorage.setItem('token', res.token)
          sessionStorage.setItem('memberId', res.memberId)
          sessionStorage.setItem('phone', res.phone)
          this.repayment()
        })
        .catch(() => {
          this.$hideLoading()
        })
    },
    countDownStart() {
      this.$refs.countDown.start()
    },
    countDownFinished() {
      this.$refs.countDown.reset()
      this.showCountDown = false
    }
  }
}
</script>

<style scoped></style>
